import React from 'react';
import BodyAuth from '../login/part/BodyAuth';
import { useWindowSize } from '../common/helpers/sizeHelper';
import { DEEP_LINK } from '../common/data/siteConfig';
import google_play from './google-play.png';
import LOGIN1 from './login_1.png';
import LOGIN2 from './login_2.png';
import { DEMO } from '../common/data/siteConfig';
import LoginIcon from '../common/icons/LoginIcon';

export default function TutorialApk() {
  const windowSize = useWindowSize();

  return (
    <BodyAuth
      title={'Cara Install Aplikasi Skoolas'}
      width={
        windowSize[0] < 500 ? (windowSize[0] > 450 ? 450 : windowSize[0]) : 500
      }
      demo={DEMO}
    >
      <style>{`
        .hide-scroll::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <div style={{ position: 'relative' }}>
        <div
          className='content has-text-left'
          style={{
            padding: '0 20px',
            maxHeight: '60vh',
            overflowY: 'auto',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          }}
        >
          <ol className='ml-5'>
            <li className='mb-3'>
              <strong>Download Aplikasi</strong>
              <br />
              <span className='is-size-7 has-text-grey'>
                Klik link berikut untuk mengunduh{' '}
                <a
                  href='https://play.google.com/store/apps/details?id=com.skoolasapp'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ fontWeight: 'bold', color: '#3e8ed0' }}
                >
                  Aplikasi Portal Skoolas
                </a>
                .
              </span>
            </li>
            <li className='mb-3'>
              <strong>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: 4 }}>Install Aplikasi dari</span>
                  <img
                    src={google_play}
                    alt=''
                    style={{ width: 17, height: 17 }}
                  />{' '}
                  <span style={{ marginLeft: 2 }}>Play Store</span>
                </span>
              </strong>
              <span className='is-size-7 has-text-grey'>
                Setelah menginstall, klik{' '}
                <a
                  href={`skoolas://setup?school=${DEEP_LINK}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ fontWeight: 'bold', color: '#3e8ed0' }}
                >
                  link
                </a>{' '}
                ini untuk membuka aplikasi dan mengisikan otomatis website
                sekolah di halaman login.
              </span>
            </li>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 8,
                marginBottom: 8,
              }}
            >
              <img src={LOGIN1} style={{ height: 300 }} alt='' />
              <img src={LOGIN2} style={{ height: 300 }} alt='' />
            </div>
            <li>
              <strong>Atau isikan manual</strong>
              <br />
              <span className='is-size-7 has-text-grey'>
                website sekolah <strong>"{DEEP_LINK}"</strong> dan kemudian
                isikan <strong>username</strong> dan
                <strong> password</strong> anda
              </span>
            </li>
          </ol>
        </div>
        <div
          style={{
            position: 'absolute',
            bottom: -28,
            right: 20,
            zIndex: 1000,
          }}
        >
          <div
            className='is-link is-size-7 is-small is-rounded is-outlined flex justify-end align-center hand-pointer px-2 py-1'
            onClick={() => window.history.back()}
          >
            <LoginIcon size={15} color={'#495fc7'} />
            <span className='ml-1'>Kembali</span>
          </div>
        </div>
      </div>
    </BodyAuth>
  );
}
